export enum RequestTypeEnum {
  New = 1,
  Existing = 2,
}
